<style lang="scss" scoped>
.slide-3 {
  background-image: url("../../../assets/module2/slide3/background-01.jpg");
  background-position: center;
  background-size: cover;
  padding-top: 100px;
  height: calc(100% - 100px);
}
.heading1,
.heading2 {
  color: #c5d43b;
  font-size: 70px;
  transform: rotate(-5deg);
  transform-origin: 10% 0;
  margin-left: -30px;
}
.heading2 {
  margin-left: 30px;
}
.heading3 {
  font-size: 100px;
}
.heading4 {
  color: #09509c;
  font-size: 50px;
  width: 70%;
}
.content {
  margin-top: 50px;
}
</style>

<template>
  <div class="slide-3">
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <h1
            class="heading1"
            v-html="$t('module2.slide3.heading1')"
            v-show="slideIndex == 2"
          ></h1>
        </transition>
        <transition name="fadeLeft" appear>
          <h1
            class="heading2 delay-1"
            v-html="$t('module2.slide3.heading2')"
            v-show="slideIndex == 2"
          ></h1>
        </transition>
        <transition name="fadeLeft" appear>
          <h1
            class="heading3 delay-2"
            v-html="$t('module2.slide3.heading3')"
            v-show="slideIndex == 2"
          ></h1>
        </transition>
        <transition name="fadeLeft" appear>
          <h1
            class="heading4 delay-3"
            v-html="$t('module2.slide3.heading4')"
            v-show="slideIndex == 2"
          ></h1>
        </transition>
        <transition name="fadeLeft" appear>
          <div class="content delay-4" v-show="slideIndex == 2">
            <p v-html="$t('module2.slide3.content')"></p>
          </div>
        </transition>
      </div>
      <div class="page page-right">
        <transition name="fadeUp" appear>
          <img
            v-show="slideIndex == 2"
            src="@/assets/module2/slide3/frank-01.png"
            class="chars delay-6"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
